module.exports = __webpack_public_path__ + "static/media/KTSG.f6738427.png";